(function () {
  function initAnnouncementBar(root) {
    var wraps = root.querySelectorAll('.kk-topbar__announcements');
    wraps.forEach(function (wrap) {
      if (wrap.dataset.kkInitialized === 'true') return;
      wrap.dataset.kkInitialized = 'true';

      var slides = wrap.querySelectorAll('.kk-topbar__message');
      var dots = wrap.parentElement.querySelectorAll('.kk-topbar__dot');
      if (slides.length < 2) return;

      var current = 0;
      var timer = null;

      function show(index) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dots[current]) dots[current].classList.add('is-active');
      }

      function next() { show(current + 1); }
      function prev() { show(current - 1); }

      function startTimer() {
        var interval = parseInt(wrap.dataset.interval, 10) || 5000;
        timer = setInterval(next, interval);
      }
      function stopTimer() {
        if (timer) clearInterval(timer);
      }

      if (wrap.dataset.autoRotate === 'true') {
        startTimer();
        wrap.addEventListener('mouseenter', stopTimer);
        wrap.addEventListener('mouseleave', startTimer);
      }

      var prevBtn = wrap.querySelector('.kk-topbar__arrow--prev');
      var nextBtn = wrap.querySelector('.kk-topbar__arrow--next');
      if (prevBtn) prevBtn.addEventListener('click', prev);
      if (nextBtn) nextBtn.addEventListener('click', next);

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(parseInt(dot.dataset.dotIndex, 10));
        });
      });
    });
  }

  // Normal page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAnnouncementBar(document);
    });
  } else {
    initAnnouncementBar(document);
  }

  // Re-init when the theme editor adds/reloads this section
  document.addEventListener('shopify:section:load', function (event) {
    initAnnouncementBar(event.target);
  });
})();
